import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileLines, faLock, faCircleCheck, faClock, faBullhorn } from '@fortawesome/free-solid-svg-icons'

const steps = [
  {
    number: '01',
    title: 'Isi Formulir Laporan',
    desc: 'Lengkapi formulir dengan informasi pelanggaran secara detail. Identitas Anda sepenuhnya dilindungi.',
    icon: faFileLines,
  },
  {
    number: '02',
    title: 'Simpan Kode Pelapor',
    desc: 'Sistem akan memberikan kode unik untuk memantau perkembangan laporan tanpa mengungkap identitas Anda.',
    icon: faLock,
  },
  {
    number: '03',
    title: 'Laporan Diverifikasi',
    desc: 'Tim independen kami memverifikasi setiap laporan dan menentukan tindak lanjut yang tepat.',
    icon: faCircleCheck,
  },
  {
    number: '04',
    title: 'Pantau Perkembangan',
    desc: 'Gunakan kode pelapor untuk memantau status dan hasil penanganan laporan Anda secara berkala.',
    icon: faClock,
  },
]

export default function CaraKerjaSection() {
  return (
    <section id="cara-kerja" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-blue-600 text-sm font-bold uppercase tracking-widest">Cara Kerja</span>
          <h2 className="mt-3 text-3xl lg:text-4xl font-extrabold text-slate-900">Mudah, Aman, dan Terstruktur</h2>
          <p className="mt-4 text-slate-500 max-w-lg mx-auto">
            Proses pelaporan dirancang sesederhana mungkin agar siapa pun dapat melaporkan dengan mudah tanpa hambatan teknis.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={step.number} className="relative group">
              {/* Connector line */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-px bg-slate-200 z-0 -translate-x-1/2" />
              )}
              <div className="relative bg-white border border-slate-100 hover:border-blue-200 hover:shadow-lg rounded-2xl p-6 transition-all h-full">
                <div className="flex items-start gap-4 mb-4">
                  <span className="text-4xl font-black text-blue-100 group-hover:text-blue-200 transition-colors leading-none">{step.number}</span>
                  <div className="w-10 h-10 bg-blue-50 group-hover:bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0 mt-1 transition-colors">
                    <FontAwesomeIcon icon={step.icon} className="w-5 h-5 text-blue-600" />
                  </div>
                </div>
                <h3 className="font-bold text-slate-800 mb-2">{step.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 text-center">
          <a href="#buat-laporan"
            className="inline-flex items-center gap-2 px-8 py-4 bg-blue-700 hover:bg-blue-600 text-white font-bold rounded-xl shadow-lg shadow-blue-900/20 transition-all hover:scale-105">
            <FontAwesomeIcon icon={faBullhorn} className="w-5 h-5" />
            Mulai Buat Laporan
          </a>
        </div>
      </div>
    </section>
  )
}
